import { render, staticRenderFns } from "./BarrasRegion.vue?vue&type=template&id=3b6586ea&"
import script from "./BarrasRegion.vue?vue&type=script&lang=js&"
export * from "./BarrasRegion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports